import { addIcons } from 'oh-vue-icons';

import {
  FaArrowAltCircleLeft,
  FaCartPlus,
  FaCheck,
  FaCloudDownloadAlt,
  FaEraser,
  FaEyeDropper,
  FaFileDownload,
  FaFileExport,
  FaFileInvoiceDollar,
  FaHandsHelping,
  FaHistory,
  FaListOl,
  FaPlus,
  FaPlusSquare,
  FaRegularClock,
  FaRegularEdit,
  FaRegularFolderOpen,
  FaRegularSave,
  FaRegularTrashAlt,
  FaRegularWindowClose,
  FaSearch,
  FaSearchPlus,
  FaShippingFast,
  FaShopify,
  FaShoppingBasket,
  FaShoppingCart,
  FaSortAmountDown,
  FaTrash,
  FaTrashAlt,
  FaTruck,
  FaUserCircle,
  FaUserPlus,
  FaUsers,
  FaAngleUp,
  FaAngleDown,
  FaTimes,
  FaSpinner,
  FaMapMarkedAlt,
} from 'oh-vue-icons/icons/fa';

import {
  BiArrowClockwise,
  BiArrowDown,
  BiArrowLeftRight,
  BiArrowLeftSquare,
  BiArrowRepeat,
  BiArrowReturnLeft,
  BiArrowUpSquareFill,
  BiBag,
  BiBagCheck,
  BiBagCheckFill,
  BiBagFill,
  BiBagPlusFill,
  BiBarChartFill,
  BiBasket,
  BiBasketFill,
  BiBatteryFull,
  BiBook,
  BiBookmark,
  BiBookmarkCheckFill,
  BiBookmarkPlus,
  BiBorderWidth as BiBordderWidth,
  BiBoxArrowInUp,
  BiBoxArrowUpRight,
  BiBoxSeam,
  BiBraces,
  BiBug,
  BiBugFill,
  BiBuilding,
  BiBullseye,
  BiCalculator,
  BiCalculatorFill,
  BiCalendar,
  BiCalendar2Event,
  BiCalendar2PlusFill,
  BiCalendar3WeekFill,
  BiCalendarCheck,
  BiCalendarEvent,
  BiCamera,
  BiCardChecklist,
  BiCardHeading,
  BiCardList,
  BiCardText,
  BiCart,
  BiCart4,
  BiCartCheck,
  BiCartCheckFill,
  BiCartFill,
  BiCartPlus,
  BiCartPlusFill,
  BiCash,
  BiCashCoin,
  BiCashStack,
  BiChatLeftDots,
  BiChatTextFill,
  BiCheck,
  BiCheck2Circle,
  BiCheck2Square,
  BiCheckAll,
  BiCheckCircle,
  BiCheckCircleFill,
  BiCircleFill,
  BiClipboard2Check,
  BiClipboardData,
  BiClockHistory,
  BiCodeSlash,
  BiCreditCardFill,
  BiCurrencyExchange,
  BiDashCircleFill,
  BiDoorClosed,
  BiDot,
  BiDownload,
  BiGear as BiEngine,
  BiEraserFill,
  BiExclamationCircleFill,
  BiEye,
  BiEyeFill,
  BiFileEarmarkArrowDown,
  BiFileEarmarkBarGraphFill,
  BiFileEarmarkSpreadsheetFill,
  BiFilePerson,
  BiFiles,
  BiFiletypeCsv,
  BiFiletypeDoc,
  BiFiletypeJson,
  BiFiletypeXml,
  BiFilter,
  BiFilterRight,
  BiFilterSquare,
  BiFilterSquareFill,
  BiFlag,
  BiFolder,
  BiFolderSymlink,
  BiFonts,
  BiForwardFill,
  BiFunnel,
  BiGear,
  BiGearFill,
  BiGraphUpArrow,
  BiGrid,
  BiGridFill,
  BiHouse,
  BiInfoCircle,
  BiInfoCircleFill,
  BiInfoSquareFill,
  BiJournalBookmark,
  BiJournalBookmarkFill,
  BiKey,
  BiKeyFill,
  BiLayerForward,
  BiLink,
  BiList,
  BiListColumns,
  BiListColumnsReverse,
  BiListOl,
  BiListUl,
  BiLock,
  BiMarkdown,
  BiMenuButtonWideFill,
  BiMortarboard,
  BiPaperclip,
  BiPatchCheck,
  BiPencil,
  BiPencilFill,
  BiPencilSquare,
  BiPeople,
  BiPeopleFill,
  BiPerson,
  BiPersonBadgeFill,
  BiPersonPlus,
  BiPhoneVibrate,
  BiPinAngle,
  BiPlayFill,
  BiPlus,
  BiPlusCircle,
  BiPlusCircleDotted,
  BiPlusCircleFill,
  BiPlusSquareFill,
  BiPostcard,
  BiPrinterFill,
  BiQrCodeScan,
  BiQuestionCircle,
  BiSave,
  BiSearch,
  BiSend,
  BiSendCheck,
  BiSendCheckFill,
  BiSendFill,
  BiSendPlusFill,
  BiShareFill,
  BiShieldExclamation,
  BiStopFill,
  BiStopwatch,
  BiTag,
  BiTextParagraph,
  BiThreeDots,
  BiTicketPerforatedFill,
  BiTrash,
  BiTrashFill,
  BiTruck,
  BiUiChecks,
  BiUnlock,
  BiUpload,
  BiViewList,
  BiWifi,
  BiWifiOff,
  BiX,
  BiXCircleFill,
} from 'oh-vue-icons/icons/bi';

import {
  MdAbc,
  MdAccounttreeRound,
  MdAdd,
  MdAdminpanelsettingsRound,
  MdAirplaneticketOutlined,
  MdArrowrightaltSharp,
  MdArticle,
  MdAttachmoney,
  MdBlockSharp,
  MdBookmarkremoveTwotone,
  MdBuildTwotone,
  MdCalendarmonthRound,
  MdCalendarmonthOutlined,
  MdCalendarviewweek,
  MdCancelRound,
  MdChangehistoryRound,
  MdCheckcircle,
  MdCheckcircleSharp,
  MdCheckcircleoutlineRound,
  MdClose,
  MdCloseTwotone,
  MdCloudsyncRound,
  MdCodeTwotone,
  MdContentcopy,
  MdContentcopyOutlined,
  MdContentpastesearchTwotone,
  MdCopyallTwotone,
  MdCurrencyexchangeSharp,
  MdCurrencyexchangeTwotone,
  MdDashboardTwotone,
  MdDashboardcustomize,
  MdDatathresholding,
  MdDeleteRound,
  MdDeleteforever,
  MdDeleteforeverOutlined,
  MdDeletesweepRound,
  MdDifferenceRound,
  MdEditnote,
  MdEditnoteTwotone,
  MdFilteraltOutlined,
  MdFilteraltoff,
  MdFilteraltoffRound,
  MdFilteraltoffTwotone,
  MdFingerprintRound,
  MdFormatlistnumberedTwotone,
  MdFullscreen,
  MdGroupOutlined,
  MdGroupremoveTwotone,
  MdGroupsOutlined,
  MdGroupsTwotone,
  MdHomeOutlined,
  MdInfo,
  MdKeyboardarrowleftTwotone,
  MdKeyboardarrowrightTwotone,
  MdKeyboardbackspace,
  MdLegendtoggle as MdLegendToggle,
  MdLibraryaddcheckOutlined,
  MdListaltOutlined,
  MdLocalofferTwotone,
  MdLoginTwotone,
  MdManagehistory,
  MdMenuRound,
  MdMenuopen,
  MdMobilefriendly,
  MdMorehorizRound,
  MdMorevert,
  MdNotealtOutlined,
  MdPermscanwifiSharp,
  MdPersonaddaltRound,
  MdPortablewifioffTwotone,
  MdQuerystats,
  MdReadmore,
  MdRefresh,
  MdRefreshSharp,
  MdRefreshTwotone,
  MdRemovecircleoutlineRound,
  MdRemoveredeyeRound,
  MdSaveOutlined,
  MdSaveRound,
  MdSearch,
  MdSearchOutlined,
  MdShoppingbagTwotone,
  MdStopcircleSharp,
  MdStackedbarchartRound,
  MdStreetviewSharp,
  MdSwitchrightOutlined,
  MdTextfields,
  MdUndoRound,
  MdUnfoldmoreSharp,
  MdViewlist,
  MdViewlistRound,
  MdViewsidebar,
  MdViewlistSharp,
  MdViewlistTwotone,
  MdVoiceoveroffRound,
  MdWifitetheringerrorroundedOutlined,
  MdWindowTwotone,
  MdImage,
  MdInsertchartTwotone,
  MdInsertpagebreakSharp,
  MdMessage,
  MdDelete,
  MdSmartbutton,
  MdDoneRound,
  MdKeyboardarrowdown,
  MdThumbupoffalt,
  MdThumbdownoffalt,
  MdHistorytoggleoff,
  MdCancelOutlined,
  MdClouddone,
  MdCalltoaction,
  MdInsertchart,
  MdCalendarmonthTwotone,
  MdPlaylistplayTwotone,
  MdViewcolumn,
  MdTablerowsRound,
  MdDynamicfeedRound,
  MdViewweek,
  MdVerticalalignbottomRound,
  MdSmartscreenOutlined,
  MdFullscreenRound,
  MdFormatlistnumberedRound,
  MdSmsfailedTwotone,
  MdCloseRound,
  MdTablechart,
  MdTabTwotone,
  MdPlaylistaddRound,
  MdBackuptableOutlined,
  MdMorevertTwotone,
  MdRestorefromtrashTwotone,
  MdRestorefromtrashRound,
  MdContentpaste,
  MdKeyboarddoublearrowdownSharp,
  MdKeyboarddoublearrowrightRound,
  MdKeyboardarrowright,
  MdZoomoutRound,
  MdOpenwithRound,
  MdZoominRound,
  MdPivottablechartTwotone,
  MdTabletRound,
} from 'oh-vue-icons/icons/md';

import {
  GiBrain,
} from 'oh-vue-icons/icons/gi';

import {
  SiGooglemaps,
} from 'oh-vue-icons/icons/si';

const selectedIcons = [
  MdAbc,
  MdAccounttreeRound,
  MdAdd,
  MdAdminpanelsettingsRound,
  MdAirplaneticketOutlined,
  MdArrowrightaltSharp,
  MdArticle,
  MdAttachmoney,
  MdBlockSharp,
  MdBookmarkremoveTwotone,
  MdBuildTwotone,
  MdCalendarmonthRound,
  MdCalendarmonthOutlined,
  MdCalendarviewweek,
  MdCancelRound,
  MdChangehistoryRound,
  MdCheckcircle,
  MdCheckcircleSharp,
  MdCheckcircleoutlineRound,
  MdClose,
  MdCloseTwotone,
  MdCloudsyncRound,
  MdCodeTwotone,
  MdContentcopy,
  MdContentcopyOutlined,
  MdContentpastesearchTwotone,
  MdCopyallTwotone,
  MdCurrencyexchangeSharp,
  MdCurrencyexchangeTwotone,
  MdDashboardTwotone,
  MdDashboardcustomize,
  MdDatathresholding,
  MdDelete,
  MdDeleteRound,
  MdDeleteforever,
  MdDeleteforeverOutlined,
  MdDeletesweepRound,
  MdDifferenceRound,
  MdEditnote,
  MdEditnoteTwotone,
  MdFilteraltOutlined,
  MdFilteraltoff,
  MdFilteraltoffRound,
  MdFilteraltoffTwotone,
  MdFingerprintRound,
  MdFormatlistnumberedTwotone,
  MdFullscreen,
  MdGroupOutlined,
  MdGroupremoveTwotone,
  MdGroupsOutlined,
  MdGroupsTwotone,
  MdHomeOutlined,
  MdInfo,
  MdKeyboardarrowleftTwotone,
  MdKeyboardarrowrightTwotone,
  MdKeyboardbackspace,
  MdLegendToggle,
  MdLibraryaddcheckOutlined,
  MdListaltOutlined,
  MdLocalofferTwotone,
  MdLoginTwotone,
  MdManagehistory,
  MdMenuRound,
  MdMenuopen,
  MdMobilefriendly,
  MdMorehorizRound,
  MdMorevert,
  MdNotealtOutlined,
  MdPermscanwifiSharp,
  MdPersonaddaltRound,
  MdPortablewifioffTwotone,
  MdQuerystats,
  MdReadmore,
  MdRefresh,
  MdRefreshSharp,
  MdRefreshTwotone,
  MdRemovecircleoutlineRound,
  MdRemoveredeyeRound,
  MdSaveOutlined,
  MdSaveRound,
  MdSearch,
  MdSearchOutlined,
  MdShoppingbagTwotone,
  MdSmartbutton,
  MdStopcircleSharp,
  MdStackedbarchartRound,
  MdStreetviewSharp,
  MdSwitchrightOutlined,
  MdTextfields,
  MdUndoRound,
  MdUnfoldmoreSharp,
  MdViewlist,
  MdViewlistRound,
  MdViewsidebar,
  MdViewlistSharp,
  MdViewlistTwotone,
  MdVoiceoveroffRound,
  MdWifitetheringerrorroundedOutlined,
  MdWindowTwotone,
  MdImage,
  MdInsertchartTwotone,
  MdInsertpagebreakSharp,
  MdMessage,
  MdDoneRound,
  MdKeyboardarrowdown,
  MdThumbupoffalt,
  MdThumbdownoffalt,
  MdHistorytoggleoff,
  MdCancelOutlined,
  MdClouddone,
  MdCalltoaction,
  MdInsertchart,
  MdCalendarmonthTwotone,
  MdPlaylistplayTwotone,
  MdViewcolumn,
  MdTablerowsRound,
  MdDynamicfeedRound,
  MdViewweek,
  MdVerticalalignbottomRound,
  MdSmartscreenOutlined,
  MdFullscreenRound,
  MdFormatlistnumberedRound,
  MdSmsfailedTwotone,
  MdCloseRound,
  MdTablechart,
  MdTabTwotone,
  MdPlaylistaddRound,
  MdBackuptableOutlined,
  MdMorevertTwotone,
  MdRestorefromtrashRound,
  MdContentpaste,
  MdKeyboarddoublearrowdownSharp,
  MdKeyboarddoublearrowrightRound,
  MdKeyboardarrowright,
  MdZoomoutRound,
  MdOpenwithRound,
  MdZoominRound,
  MdPivottablechartTwotone,
  MdTabletRound,
  FaArrowAltCircleLeft,
  FaCartPlus,
  FaCheck,
  FaCloudDownloadAlt,
  FaEraser,
  FaEyeDropper,
  FaFileDownload,
  FaFileExport,
  FaFileInvoiceDollar,
  FaHandsHelping,
  FaHistory,
  FaListOl,
  FaPlus,
  FaPlusSquare,
  FaRegularClock,
  FaRegularEdit,
  FaRegularFolderOpen,
  FaRegularSave,
  FaRegularTrashAlt,
  FaRegularWindowClose,
  FaSearch,
  FaSearchPlus,
  FaShippingFast,
  FaShopify,
  FaShoppingBasket,
  FaShoppingCart,
  FaSortAmountDown,
  FaTrash,
  FaTrashAlt,
  FaTruck,
  FaUserCircle,
  FaUserPlus,
  FaUsers,
  FaAngleUp,
  FaAngleDown,
  FaTimes,
  FaSpinner,
  BiArrowClockwise,
  BiArrowLeftRight,
  BiArrowLeftSquare,
  BiArrowRepeat,
  BiArrowReturnLeft,
  BiArrowUpSquareFill,
  BiArrowDown,
  BiBag,
  BiBagCheck,
  BiBagCheckFill,
  BiBagFill,
  BiBagPlusFill,
  BiBarChartFill,
  BiBasket,
  BiBasketFill,
  BiBatteryFull,
  BiBook,
  BiBookmark,
  BiBookmarkCheckFill,
  BiBookmarkPlus,
  BiBordderWidth,
  BiBoxArrowInUp,
  BiBoxArrowUpRight,
  BiBoxSeam,
  BiBraces,
  BiBug,
  BiBugFill,
  BiBuilding,
  BiBullseye,
  BiCalculator,
  BiCalculatorFill,
  BiCalendar,
  BiCalendar2Event,
  BiCalendar2PlusFill,
  BiCalendar3WeekFill,
  BiCalendarCheck,
  BiCalendarEvent,
  BiCamera,
  BiCardChecklist,
  BiCardHeading,
  BiCardList,
  BiCardText,
  BiCart,
  BiCart4,
  BiCartCheck,
  BiCartCheckFill,
  BiCartFill,
  BiCartPlus,
  BiCartPlusFill,
  BiCash,
  BiCashCoin,
  BiCashStack,
  BiChatTextFill,
  BiCheck,
  BiCheck2Circle,
  BiCheck2Square,
  BiCheckAll,
  BiCheckCircle,
  BiCheckCircleFill,
  BiCircleFill,
  BiClipboard2Check,
  BiClipboardData,
  BiClockHistory,
  BiCodeSlash,
  BiCreditCardFill,
  BiCurrencyExchange,
  BiDashCircleFill,
  BiDoorClosed,
  BiDownload,
  BiEngine,
  BiEraserFill,
  BiExclamationCircleFill,
  BiEye,
  BiEyeFill,
  BiFileEarmarkArrowDown,
  BiFileEarmarkBarGraphFill,
  BiFileEarmarkSpreadsheetFill,
  BiFilePerson,
  BiFiles,
  BiFiletypeCsv,
  BiFiletypeDoc,
  BiFiletypeJson,
  BiFiletypeXml,
  BiFilter,
  BiFilterRight,
  BiFilterSquare,
  BiFilterSquareFill,
  BiFlag,
  BiFolder,
  BiFolderSymlink,
  BiFonts,
  BiForwardFill,
  BiFunnel,
  BiGear,
  BiGearFill,
  BiGraphUpArrow,
  BiGrid,
  BiGridFill,
  BiHouse,
  BiInfoCircle,
  BiInfoCircleFill,
  BiInfoSquareFill,
  BiJournalBookmark,
  BiJournalBookmarkFill,
  BiKey,
  BiKeyFill,
  BiLayerForward,
  BiLink,
  BiList,
  BiListColumns,
  BiListColumnsReverse,
  BiListOl,
  BiListUl,
  BiLock,
  BiUnlock,
  BiMarkdown,
  BiMenuButtonWideFill,
  BiMortarboard,
  BiPaperclip,
  BiPatchCheck,
  BiPencil,
  BiPencilFill,
  BiPencilSquare,
  BiPeople,
  BiPeopleFill,
  BiPerson,
  BiPersonBadgeFill,
  BiPersonPlus,
  BiPhoneVibrate,
  BiPinAngle,
  BiPlayFill,
  BiPlus,
  BiPlusCircle,
  BiPlusCircleDotted,
  BiPlusCircleFill,
  BiPlusSquareFill,
  BiPostcard,
  BiPrinterFill,
  BiQrCodeScan,
  BiSave,
  BiSearch,
  BiSend,
  BiSendCheck,
  BiSendCheckFill,
  BiSendPlusFill,
  BiShareFill,
  BiShieldExclamation,
  BiStopFill,
  BiStopwatch,
  BiTag,
  BiTextParagraph,
  BiThreeDots,
  BiTicketPerforatedFill,
  BiTrash,
  BiTrashFill,
  BiTruck,
  BiUiChecks,
  BiUpload,
  BiViewList,
  BiWifi,
  BiWifiOff,
  BiX,
  BiXCircleFill,
  BiSendFill,
  BiQuestionCircle,
  BiDot,
  BiChatLeftDots,
  GiBrain,
  FaMapMarkedAlt,
  SiGooglemaps
];

const normalizeIconName = (name) =>
  String(name || '')
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/_/g, '-')
    .toLowerCase();

const resolvedIcons = selectedIcons.filter(Boolean);

export const registeredIconNames = Object.freeze(
  [...new Set(resolvedIcons.map((icon) => normalizeIconName(icon.name)))]
    .sort((a, b) => a.localeCompare(b))
);

export const registeredIconOptions = Object.freeze(
  registeredIconNames.map((iconName) => ({
    id: iconName,
    text: iconName,
    icon: iconName,
  }))
);

export const registerIcons = () => {
  addIcons(...resolvedIcons);
};
